import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-burial-filter',
  templateUrl: './burial-filter.component.html',
  styleUrls: ['./burial-filter.component.scss']
})
export class BurialFilterComponent {
  @Input() filterValues: any[] = [];
  @Input() filterMatchCount: number = 0;
  @Input() filterInputContractNames: string[] = [];

  @Output() addFilter = new EventEmitter<{type: string, value: any}>();
  @Output() deleteFilter = new EventEmitter<any>();
  @Output() clearFilters = new EventEmitter<void>();

  onAddFilter(type: string) {
    const inputElement = document.getElementById(`inputFilter${type}`) as HTMLInputElement;
    if (inputElement && inputElement.value) {
      this.addFilter.emit({ type, value: inputElement.value });
      inputElement.value = '';
    }
  }

  onDeleteFilter(filterValue: any) {
    this.deleteFilter.emit(filterValue);
  }

  onClearFilters() {
    this.clearFilters.emit();
  }

  onStatusChange(event: any) {
    if (event.target.value !== '0') {
      this.addFilter.emit({ type: 'Status', value: event.target.value });
      event.target.value = '0';
    }
  }
} 